export default {
    url: 'http://localhost:8000/api/'
}